document.addEventListener('DOMContentLoaded', function () {
  const teamSliderSwipers = document.querySelectorAll('[data-team-slider-swiper]');
  if (!teamSliderSwipers.length) return;

  teamSliderSwipers.forEach(teamSlider => {
    const swiper = new Swiper(teamSlider, {
      slidesPerView: 3,
      centeredSlides: true,
      loop: true,
      spaceBetween: 60,
      speed: 700,
      roundLengths: true,
      autoplay: {
        delay: 3500,
      },
      pagination: {
        el: teamSlider.querySelector('[data-team-slider-swiper-pagination]'),
        clickable: true,
      },
      navigation: {
        nextEl: teamSlider.querySelector('[data-team-slider-swiper-button-next]'),
        prevEl: teamSlider.querySelector('[data-team-slider-swiper-button-prev]'),
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 1 },
        1024: { slidesPerView: 3 },
      },
    });

    // ✅ Delegated event handler (works even on cloned slides)
    teamSlider.addEventListener('click', e => {
      const emailButton = e.target.closest('[data-email-link]');
      if (!emailButton) return;

      e.preventDefault();
      const email = emailButton.dataset.emailLink;
      const toast = emailButton
        .closest('.team-slider-section__slide')
        .querySelector('[data-email-toast]');

      if (!email || !toast) return;

      navigator.clipboard.writeText(email).then(() => {
        toast.classList.add('team-slider-section__email_toast--active');
        setTimeout(() => {
          toast.classList.remove('team-slider-section__email_toast--active');
        }, 3000);
      });
    });

    // ✅ Handle autoplay pause/resume on hover
    teamSlider.addEventListener('mouseenter', () => swiper.autoplay?.stop());
    teamSlider.addEventListener('mouseleave', () => swiper.autoplay?.start());
  });
});
